module.exports = __webpack_public_path__ + "img/deadline.34d25e1b.svg";